import CSS from 'csstype';
import React, { useState } from 'react';

import {
  BellIconSmall,
  GearIconSmall,
  MasqueradeIconSmall,
} from '~/src/dash/components/icons/misc-icons';
import { Col, Cols, fontSizing, Text, TKey, TooltipWithTranslation } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { IconV2 } from '~/src/dash/components/icons/IconV2';

type IconSlug = 'bell_small' | 'gear_small' | 'masquerade_small' | 'globe_small';

interface ISortIconProps {
  color: string;
  iconSlug?: IconSlug;
}

const Icon = ({ color, iconSlug }: ISortIconProps) => {
  switch (iconSlug) {
    case 'bell_small':
      return <BellIconSmall color={color} />;
    case 'gear_small':
      return <GearIconSmall color={color} />;
    case 'globe_small':
      return <IconV2 name='globe' small color={color} />;
    case 'masquerade_small':
      return <MasqueradeIconSmall color={color} />;
    default:
      return <></>;
  }
};

interface IIconTextButtonProps {
  activeBackgroundColor?: string;
  activeColor?: string;
  buttonStyle?: CSS.Properties;
  defaultBackgroundColor?: string;
  defaultColor?: string;
  handleOnClick: (props?: any) => void;
  hoverBackgroundColor?: string;
  hoverColor?: string;
  iconSlug?: IconSlug;
  label?: string;
  textStyle?: CSS.Properties;
  tooltip?: string;
  tooltipTKey?: TKey;
}

export const IconTextButton = ({
  buttonStyle = {},
  defaultBackgroundColor = 'inherit',
  defaultColor = publicaColors.darkGray,
  handleOnClick,
  hoverBackgroundColor = 'inherit',
  hoverColor = publicaColors.black,
  iconSlug,
  label,
  textStyle = {},
  tooltip = '',
  tooltipTKey,
}: IIconTextButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const color = isHovered ? hoverColor : defaultColor;

  const backgroundColor = isHovered ? hoverBackgroundColor : defaultBackgroundColor;

  return (
    <TooltipWithTranslation tKey={tooltipTKey} title={tooltip}>
      <button
        style={{
          display: 'inline-block',
          borderWidth: 0,
          margin: 0,
          padding: `4px ${label ? '12px' : '10px'} 4px ${iconSlug ? '10px' : '12px'}`,
          borderRadius: '6px',
          backgroundColor,
          fontFamily: 'inherit',
          whiteSpace: 'nowrap',
          cursor: 'pointer',
          border: `1px solid ${publicaColors.lightGray}`,
          ...buttonStyle,
        }}
        onClick={(e) => handleOnClick(e)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Cols
          gap='4px'
          style={{
            alignItems: 'center',
          }}
        >
          {iconSlug && (
            <Col displayFlex>
              <Icon color={color} iconSlug={iconSlug} />
            </Col>
          )}
          {label && (
            <Col>
              <Text
                disableSelect
                style={{
                  color,
                  lineHeight: 'inherit',
                  fontStyle: 'inherit',
                  fontSize: fontSizing.extraSmall,
                  ...textStyle,
                }}
              >
                {label}
              </Text>
            </Col>
          )}
        </Cols>
      </button>
    </TooltipWithTranslation>
  );
};
